var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 2.5C16.875 1.46447 16.0355 0.625 15 0.625C13.9645 0.625 13.125 1.46447 13.125 2.5V13.125H2.5C1.46447 13.125 0.625 13.9645 0.625 15C0.625 16.0355 1.46447 16.875 2.5 16.875H13.125V27.5C13.125 28.5355 13.9645 29.375 15 29.375C16.0355 29.375 16.875 28.5355 16.875 27.5V16.875H27.5C28.5355 16.875 29.375 16.0355 29.375 15C29.375 13.9645 28.5355 13.125 27.5 13.125H16.875V2.5Z",
    fill: "#666970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b38438af9f3fd75a9de19690b6f1718b.svg";
export { ForwardRef as ReactComponent };